<template>
  <ranking-page
    endpoint="/spontan/ranking/total/counts/year/finn"
    heading-danish="Rangliste - FiNN-tællinger i år"
    heading-english="Ranking - Total FiNN current year"
    is-finn
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
